import { ConciliationCaseEvent } from "@/@types/conciliation-history";
import {
  ConciliationChangeOriginEnum,
  ConciliationItemEventEnum,
} from "@/constants/conciliation-history";

import { ConciliationCaseOperationGroup } from "../types";

export const groupCaseEvents = (
  events: readonly ConciliationCaseEvent[]
): ConciliationCaseOperationGroup[] => {
  const groups: ConciliationCaseOperationGroup[] = [];
  const byOperation: Map<string, ConciliationCaseOperationGroup> = new Map();

  events.forEach((event: ConciliationCaseEvent): void => {
    const existing: ConciliationCaseOperationGroup | undefined =
      byOperation.get(event.operation_id);

    if (existing) {
      existing.events.push(event);
      return;
    }

    const group: ConciliationCaseOperationGroup = {
      operation_id: event.operation_id,
      at: event.created_at,
      events: [event],
    };

    byOperation.set(event.operation_id, group);
    groups.push(group);
  });

  return groups;
};

export const newestActionFirst = (
  groups: readonly ConciliationCaseOperationGroup[]
): ConciliationCaseOperationGroup[] => [...groups].reverse();

const CONCILIATION_EVENTS: ReadonlySet<ConciliationItemEventEnum> = new Set([
  ConciliationItemEventEnum.CONCILIATED,
  ConciliationItemEventEnum.CREATED,
]);

export const conciliationEventOf = (
  group: ConciliationCaseOperationGroup
): ConciliationCaseEvent | null =>
  group.events.find(
    (event: ConciliationCaseEvent): boolean =>
      event.origin === ConciliationChangeOriginEnum.DIVERGENCE_CONCILIATION &&
      CONCILIATION_EVENTS.has(event.event)
  ) ?? null;
